import React from 'react';
import { Divider, Menu, MenuItem, ListItemText, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const KIND_LABEL = {
  PRIVATE_LESSON: '개인레슨',
  DUET_LESSON: '듀엣레슨',
  OT: 'OT',
  GROUP_LESSON: '그룹수업',
  CONSULTATION: '상담',
  ETC: '기타',
};

/** 복사한 일정을 한 줄로 — [붙여넣기] 항목 아래 보조 설명. */
export const clipboardSummary = entry => {
  if (!entry) return '';
  const kind = KIND_LABEL[entry.kind] || '일정';
  const title = entry.title ? ` · ${entry.title}` : '';
  const time = entry.startTime ? ` · ${entry.startTime}` : '';
  return `${kind}${title}${time}`;
};

/**
 * 스케줄 카드·빈칸 우클릭 메뉴(#143).
 *
 * @param position {{ left:number, top:number }} 우클릭 좌표. null 이면 닫힌 상태.
 * @param mode 'card' = 복사하기(+ 일정 삭제), 'empty' = 붙여넣기
 * @param canCopy·canDelete 카드 메뉴 항목 표시 여부(권한)
 */
const ScheduleContextMenu = ({
  position,
  mode,
  clipboardEntry,
  onCopy,
  onPaste,
  onDelete,
  canCopy = true,
  canDelete = false,
  onClose,
}) => {
  const summary = clipboardSummary(clipboardEntry);

  return (
    <Menu
      open={!!position}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={position ? { left: position.left, top: position.top } : undefined}
      slotProps={{ paper: { sx: { minWidth: 180 } } }}>
      {mode === 'card' ? (
        [
          canCopy && (
            <MenuItem
              key="copy"
              onClick={() => {
                onCopy?.();
                onClose?.();
              }}>
              <ContentCopyIcon fontSize="small" sx={{ mr: 1, color: '#4AB3BC' }} />
              <ListItemText primary="복사하기" />
            </MenuItem>
          ),
          // 복사·삭제가 둘 다 보일 때만 사이에 구분선
          canCopy && canDelete && onDelete && <Divider key="divider" sx={{ my: '5px !important' }} />,
          canDelete && onDelete && (
            <MenuItem
              key="delete"
              onClick={() => {
                onDelete();
                onClose?.();
              }}>
              <DeleteOutlineIcon fontSize="small" sx={{ mr: 1, color: '#E5484D' }} />
              <ListItemText primary="일정 삭제" primaryTypographyProps={{ sx: { color: '#E5484D' } }} />
            </MenuItem>
          ),
        ]
      ) : (
        <MenuItem
          disabled={!clipboardEntry}
          onClick={() => {
            onPaste?.();
            onClose?.();
          }}>
          <ContentPasteIcon fontSize="small" sx={{ mr: 1, color: '#4AB3BC' }} />
          <ListItemText
            primary="붙여넣기"
            secondary={
              clipboardEntry ? (
                <Typography variant="caption" color="text.secondary">
                  {summary}
                </Typography>
              ) : (
                <Typography variant="caption" color="text.secondary">
                  복사한 일정이 없습니다
                </Typography>
              )
            }
          />
        </MenuItem>
      )}
    </Menu>
  );
};

export default ScheduleContextMenu;
